import centralApiAxios from "../../axios/centralApiAxios";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";

const getActivityListing = async (payload) => {
    const sendDate = new Date().getTime();
    let pageSize = 20;
    let createdBy = payload.selectedFilters && payload.selectedFilters.created_by && payload.selectedFilters.created_by.id ? payload.selectedFilters.created_by.id : null;
    let recordType = payload.selectedFilters && payload.selectedFilters.recordType && payload.selectedFilters.recordType.id ? payload.selectedFilters.recordType.id : null;
    let primaryRecordId = payload.selectedFilters && payload.selectedFilters.primaryRecordId && payload.selectedFilters.primaryRecordId.id ? payload.selectedFilters.primaryRecordId.id : null;
    let targetRecordId = payload.selectedFilters && payload.selectedFilters.targetRecordId && payload.selectedFilters.targetRecordId.id ? payload.selectedFilters.targetRecordId.id : null;
    let enumProcessCode = payload.selectedFilters && payload.selectedFilters.enumProcessCode && payload.selectedFilters.enumProcessCode.text ? payload.selectedFilters.enumProcessCode.text : null;
    let processCode = payload.selectedFilters && payload.selectedFilters.processCode && payload.selectedFilters.processCode.text ? payload.selectedFilters.processCode.text : "";
    processCode = processCode ? processCode : (payload.params && payload.params.processCode ? payload.params.processCode : null);
    let fromDate = payload.selectedFilters && payload.selectedFilters.fromDate ? payload.selectedFilters.fromDate : "";
    fromDate = fromDate ? fromDate : (payload.params && payload.params.fromDate ? payload.params.fromDate : null);
    let toDate = payload.selectedFilters && payload.selectedFilters.toDate ? payload.selectedFilters.toDate : "";
    toDate = toDate ? toDate : (payload.params && payload.params.toDate ? payload.params.toDate : null);
    let userName = payload.selectedFilters && payload.selectedFilters.userName && payload.selectedFilters.userName.text ? payload.selectedFilters.userName.text : "";
    let contactId = payload.selectedFilters && payload.selectedFilters.contactId && payload.selectedFilters.contactId.id ? payload.selectedFilters.contactId.id : "";
    let isSuccess = payload.params && payload.params.isSuccess ? payload.params.isSuccess : null;
    let pinned = payload.params && payload.params.pinned ? payload.params.pinned : null;
    let parentActivityGuid = payload.parentRecordId ? payload.parentRecordId : null;

    if (payload.pageNumber == -1)
    {
        pageSize = -1;
    }
  
    let url = "activities?searchText=" +
        (createdBy ? "&createdBy=" + createdBy : "") +
        (recordType ? "&recordType=" + recordType : "") +
        (primaryRecordId ? "&primaryRecordId=" + primaryRecordId : "") +
        (contactId ? "&targetRecordId=" + contactId : (targetRecordId ? "&targetRecordId=" + targetRecordId : "")) +
        (enumProcessCode ? "&enumProcessCode=" + enumProcessCode : "") +
        (processCode ? "&processCode=" + processCode : "") +
        (fromDate ? "&fromDate=" + fromDate : "") +
        (toDate ? "&toDate=" + toDate : "") +
        (userName ? "&userName=" + userName : "") +
        (isSuccess ? "&isSuccess=" + isSuccess : "") +
        (pinned ? "&pinned=" + pinned : "") +
        (parentActivityGuid ? "&parentActivityGuid=" + parentActivityGuid : "") +
        ("&pageNumber=" + payload.pageNumber) +
        (pageSize ? "&pageSize=" + pageSize : "");
    const recordActivityListReturned = await centralApiAxios.get(url, getActivityHeadersUpdated(payload));

    return {
        recordList: recordActivityListReturned,
        total_item_count: recordActivityListReturned.data.totalItemCount,
        message: null,
        responseTime: ((new Date().getTime() - sendDate) / 1000).toFixed(1),
    };
}

export default getActivityListing;